import { useNavigate } from "react-router-dom";
import { Fuel, Gauge, Settings2, User, BadgeCheck, Calendar } from "lucide-react";
import { motion } from "framer-motion";
import { formatINR, imgUrl } from "@/lib/format";

export default function CarCard({ vehicle, index = 0 }) {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
      onClick={() => navigate(`/motors/${vehicle.id}`)}
      data-testid={`car-card-${vehicle.id}`}
      className="group cursor-pointer bg-white border border-slate-200 rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:border-navy/20 transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={imgUrl(vehicle.images?.[0])} alt={vehicle.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-semibold uppercase tracking-wide bg-navy text-white">
          {vehicle.fuel_type}
        </span>
        {vehicle.sold && (
          <div className="absolute inset-0 bg-slate-900/45 flex items-center justify-center">
            <span className="px-4 py-1.5 rounded-md text-sm font-bold uppercase tracking-widest bg-gold text-navy -rotate-6 shadow-lg">Sold</span>
          </div>
        )}
      </div>
      <div className="p-5">
        <p className="font-display text-2xl font-bold text-slate-900">{formatINR(vehicle.price)}</p>
        <h3 className="mt-1.5 font-medium text-slate-900 line-clamp-1">{vehicle.title}</h3>
        <div className="mt-1 flex items-center justify-between">
          <p className="text-sm text-slate-500">{vehicle.city}</p>
          {vehicle.owner_verified && (
            <span data-testid={`car-verified-${vehicle.id}`} className="flex items-center gap-1 text-xs font-semibold text-navy bg-navy/10 px-2 py-0.5 rounded-full">
              <BadgeCheck className="h-3.5 w-3.5" /> Verified
            </span>
          )}
        </div>
        <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-2 gap-y-2 text-sm text-slate-600">
          <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4 text-gold-dark" /> {vehicle.year}</span>
          <span className="flex items-center gap-1.5"><Gauge className="h-4 w-4 text-gold-dark" /> {vehicle.km_driven.toLocaleString("en-IN")} km</span>
          <span className="flex items-center gap-1.5"><Settings2 className="h-4 w-4 text-gold-dark" /> {vehicle.transmission}</span>
          <span className="flex items-center gap-1.5"><User className="h-4 w-4 text-gold-dark" /> {vehicle.owners} owner</span>
        </div>
      </div>
    </motion.div>
  );
}
